<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemDept.query.deptName')">
                <a-input v-model="queryParam.deptName" :placeholder="$t('views.systemDept.query.deptNamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemDept.query.status')">
                <a-select :placeholder="$t('views.systemDept.query.statusPlaceholder')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in localizedStatusOptions" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.systemDept.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.systemDept.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:dept:add']">
          <a-icon type="plus" />{{ $t('views.systemDept.btn.add') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        :deptOptions="deptOptions"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
        @select-tree="getTreeselect"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered">
        <a-switch slot="status" slot-scope="text, record" @change="changeStatus($event,record)" :checked="record.status === 1 " />
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['system:dept:edit']">
            <a-icon type="edit" />{{ $t('views.systemDept.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['system:dept:add']" />
          <a @click="$refs.createForm.handleAdd(record)" v-hasPermi="['system:dept:add']">
            <a-icon type="plus" />{{ $t('views.systemDept.btn.add') }}
          </a>
          <a-divider type="vertical" v-if="record.parentId != 0" v-hasPermi="['system:dept:remove']" />
          <a @click="handleDelete(record)" v-if="record.parentId != 0" v-hasPermi="['system:dept:remove']">
            <a-icon type="delete" />{{ $t('views.systemDept.btn.delete') }}
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { listDept, delDept, updateDept, listDeptExcludeChild } from '@/api/system/dept'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Dept',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      deptOptions: [],
      loading: false,
      queryParam: {
        deptName: undefined,
        status: undefined
      },
      columns: [
        {
          title: '',
          dataIndex: 'id',
          align: 'center',
          width: 80
        },
        {
          title: '',
          dataIndex: 'deptName'
        },
        {
          title: '',
          dataIndex: 'orderNum',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          width: '30%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    localizedStatusOptions () {
      return this.localizeDictOptions(this.dict.type['sys_enable_disable'], 'views.systemDept.dict.status')
    },
    displayColumns () {
      const titleKeyByDataIndex = {
        id: 'views.systemDept.column.id',
        deptName: 'views.systemDept.column.deptName',
        orderNum: 'views.systemDept.column.orderNum',
        status: 'views.systemDept.column.status',
        createTime: 'views.systemDept.column.createTime',
        operation: 'views.systemDept.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  methods: {
    localizeDictOptions (options, keyPrefix) {
      return (options || []).map(item => {
        const i18nKey = `${keyPrefix}.${item.value}`
        return {
          ...item,
          label: this.$te(i18nKey) ? this.$t(i18nKey) : item.label
        }
      })
    },
    changeStatus (e, record) {
      const oldStatus = record.status
      const newOldRecord = JSON.parse(JSON.stringify(record))
      newOldRecord.status = e ? 1 : 0
      const status = e ? 1 : 0
      const action = oldStatus === 0
        ? this.$t('views.systemDept.status.enable')
        : this.$t('views.systemDept.status.disable')
      updateDept(newOldRecord).then((res) => {
        if (res.success) {
          record.status = status
          this.$message.success(this.$t('views.systemDept.msg.statusSuccess', { action }), 3)
        } else {
          record.status = oldStatus
          this.$message.error(this.$t('views.systemDept.msg.statusFail', { action, message: res.message }), 3)
        }
      }).catch(() => {
        this.$message.error(this.$t('views.systemDept.msg.statusException', { action }), 3)
      })
    },
    getList () {
      this.loading = true
      listDept(this.queryParam).then(response => {
        this.list = this.handleTree(response.data, 'id')
        this.loading = false
      })
    },
    getTreeselect (row) {
      if (!row) {
        listDept().then(response => {
          this.deptOptions = this.handleTree(response.data, 'id')
        })
      } else {
        listDeptExcludeChild(row.id).then(response => {
          this.deptOptions = this.handleTree(response.data, 'id')
        })
      }
    },
    handleQuery () {
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        deptName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    handleDelete (row) {
      const that = this
      const deptId = row.id
      this.$confirm({
        title: this.$t('views.systemDept.confirm.deleteTitle'),
        content: this.$t('views.systemDept.confirm.deleteContent', { ids: deptId }),
        onOk () {
          return delDept(deptId)
            .then(() => {
              that.getList()
              that.$message.success(that.$t('views.systemDept.msg.deleteSuccess'), 3)
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
